import { PatientStatsPageType } from '@/constants/patient-stats'

export const PATIENT_NOUN: string = process.env.VUE_APP_PATIENT_NOUN || 'Patient'
export const INCLUDE_DASHBOARDS = JSON.parse((process.env.VUE_APP_INCLUDE_DASHBOARDS || 'True').toLowerCase())
export const HOME_PAGE = (process.env.VUE_APP_HOMEPAGE || 'home').toLowerCase()

export const NURSING_HOME_MENU = JSON.parse((process.env.VUE_APP_NURSING_HOME_MENU || 'False').toLowerCase())

export const INCLUDE_CLIENTS = JSON.parse((process.env.VUE_APP_INCLUDE_CLIENTS || 'True').toLowerCase())

export const INCLUDE_MAP = JSON.parse((process.env.VUE_APP_INCLUDE_MAP || 'False').toLowerCase())
export const INCLUDE_REPORTS = JSON.parse((process.env.VUE_APP_INCLUDE_REPORTS || 'True').toLowerCase())
export const INCLUDE_EXERCISES = JSON.parse((process.env.VUE_APP_INCLUDE_EXERCISES || 'True').toLowerCase())
export const INCLUDE_LIVE_METRICS = JSON.parse((process.env.VUE_APP_INCLUDE_LIVE_METRICS || 'True').toLowerCase())
export const INCLUDE_INHALERS = JSON.parse((process.env.VUE_APP_INCLUDE_INHALERS || 'True').toLowerCase())
export const CUSTOM_PATIENT_STATS_PAGE_TYPE = process.env.VUE_APP_CUSTOM_PATIENT_STATS_PAGE_TYPE || false
export const SHOW_LOCATION_BY_VIBE = process.env.VUE_APP_SHOW_LOCATION_BY_VIBE || false

export const AUTO_REFRESH_PATIENTS = JSON.parse((process.env.VUE_APP_AUTO_REFRESH_PATIENTS || 'False').toLowerCase())
export const INCLUDE_SHIFT_AND_ROUND_REPORTS = process.env.VUE_APP_INCLUDE_SHIFT_AND_ROUND_REPORTS || false
export const INCLUDE_LIVE_DASHBOARD = JSON.parse((process.env.VUE_APP_INCLUDE_LIVE_DASHBOARD || 'True').toLowerCase())

export const INCLUDE_VITALS_PROGRAM = JSON.parse((process.env.VUE_APP_VITALS_PROGRAM_ENABLED || 'True').toLowerCase())

export const INCLUDE_EXERCISE_PROGRAMS = JSON.parse(
  (process.env.VUE_APP_INCLUDE_EXERCISE_PROGRAMS || 'True').toLowerCase()
)

/*
Currently for dev only - API is not yet implemented
*/
export const INCLUDE_DEVICE_MANAGEMENT = JSON.parse(
  (process.env.VUE_APP_INCLUDE_DEVICE_MANAGEMENT || 'True').toLowerCase()
)

/*
for Japan project - enables an audio/visual alert on 'All Metrics Live' screen when vital signs pass certain thresholds (see @/constants/live-dashboard - LIVE_DASHBOARD_VITAL_SIGN_THRESHOLDS)
*/
export const INCLUDE_ALL_METRICS_LIVE_AUDIO_ALERT = process.env.VUE_APP_INCLUDE_ALL_METRICS_LIVE_AUDIO_ALERT || false
